import './styles/app.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { installLinkDefaultActionGuard } from './lib/utils/link-navigation.js';

installLinkDefaultActionGuard();

const app = mount(App, {
  target: document.getElementById('app')
});

export default app;
